module.exports = __webpack_public_path__ + "img/header.093e0572.png";